import React, { type ReactNode } from 'react';
import { isNil } from 'lodash';
import { IconButton } from '@fiverr-private/button';
import { Box, tokens } from '@fiverr-private/theme';
import CircularProgress from './CircularProgress';

interface ControlsIconButtonProps {
  children: ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  percentagePlayed?: number;
  ariaLabel: string;
}

const ControlsIconButton = ({ children, onClick, percentagePlayed, ariaLabel }: ControlsIconButtonProps) => (
  <Box
    borderRadius="circle"
    height={32}
    width={32}
    backgroundColor="grey_1200"
    opacity={'0.8'}
    display="flex"
    alignItems="center"
    justifyContent="center"
    position="relative"
    transition={`opacity ${tokens.animationDuration.slow1}`}
  >
    {!isNil(percentagePlayed) && <CircularProgress percentage={percentagePlayed} />}
    <IconButton
      variant="ghost"
      shape="circle"
      onClick={onClick}
      size="xs"
      aria-label={ariaLabel}
      background={{ default: 'transparent', hover: 'transparent', active: 'transparent' }}
    >
      {children}
    </IconButton>
  </Box>
);

ControlsIconButton.displayName = 'ControlsIconButton';
export default ControlsIconButton;
